
import manualButton from '../manual-button';
import doubleDate from './double-date';
import dateFormat from 'vux/src/tools/date/format.js'


export default {
name: "contact-p",
components: {
manualButton,
doubleDate
},
props:['isTodo'],
data() {
return {
isManualShow:true,
contactStateList:[
{name: '全部', code: '', selected: true},
{name: '草稿', code: 'send'},
{name: '审批中', code: 'check'},
{name: '供应商确认状态', code: 'confirm'},
{name: '已发布', code: 'end'},
{name: '已作废', code: 'delete'},
],
contractBase:{
matName:'',
contractName:'',
companyCod:'',
person:''
},
contractTypeList:[],
checkedDtoList:[],
purorgList:[],
startTime:'',
endTime:'',
}
},
methods: {
closeReset(){
this.isManualShow=true;
this.$refs.manulaDate.show=false;
},
getcontractTypeList(){
this.$get('api/dict-tables/search-with-list?dictCode=contractType').then(data=>{
data.dictItems.forEach(val=>{
let item = {
name: val.value,
code: val.code,
};
this.contractTypeList.push(item)
})
this.contractTypeList.unshift({code: '', name: '全部'})
})

},
concactInputChange(e,filed){
if(e){
this.checkerChange(e,filed.filed,filed.name,filed.option)
}
},
checkerChange(value,name,chinese,option="IN"){
this.checkedDtoList=this.checkedDtoList.filter(val=>val.name!=name)
this.checkedDtoList.push({name,code:value,ch:chinese,option:option});
},
chooseDate(e){
this.isManualShow=false;
this.$refs.manulaDate.dateTitle=e;
this.$refs.manulaDate.show=true;
},
dateChoose(e){
if(e.startTime){
this.startTime=dateFormat( new Date(e.startTime).getTime(),"YYYY-MM-DD")
this.endTime=dateFormat( new Date(e.endTime).getTime(),"YYYY-MM-DD")
if(this.isTodo){
this.checkerChange([e.startTime,e.endTime],'signDate','date','BTD')
}else {
this.checkerChange([e.startTime,e.endTime],'contractBase.signDate','date','BTD')
}
}else {
this.startTime='';
this.endTime='';
this.checkedDtoList=this.checkedDtoList.filter(val=>val.ch!='date')
}
this.isManualShow=true;
},
inputReset(name){
this.checkedDtoList=this.checkedDtoList.filter(val=>val.ch!=name)
},

getPurorgList() {
this.$loadingShow();
this.$get('api/purorg').then((data) => {
data.forEach(val=>{
val.name=val.purorgName;
val.code=val.purorgCode
})
this.purorgList = data;
this.purorgList.unshift({code: '', name: '全部'})
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
},
reload(){
this.checkedDtoList=[];
this.contractBase={
matName:'',
contractName:'',
companyCod:'',
person:''
}
this.startTime='';
this.endTime='';
this.show=false;
this.$nextTick(()=>{
this.show=true;
})
}
},

created() {
this.getPurorgList();
this.getcontractTypeList();
}


}



// WEBPACK FOOTER //
// ./src/components/manual-search/contact-p.vue